import { isNil } from 'lodash';

import { loading, success, handleErrorException, error } from 'State/actions';

import * as types from './types';

import * as SelectedForVerificationSelectors from './selectors';

export const getSelectedForVerification = (pageObj) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const applicationFilters = SelectedForVerificationSelectors.getApplicationFilters(
        getState()
      );

      pageObj = { ...applicationFilters, ...pageObj };

      dispatch(loading(types.SELECTED_FOR_VERIFICATION_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        'Application/SelectedForVerification',
        pageObj
      );

      dispatch({
        type: types.GET_SELECTED_FOR_VERIFICATION,
        payload: {
          data: response.data,
        },
      });
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.SELECTED_FOR_VERIFICATION_ERROR, {
          Title: 'Error',
          Message: 'Unable to load application details.',
        })
      );
    } finally {
      dispatch(loading(types.SELECTED_FOR_VERIFICATION_LOADING, false));
    }
  };
};

export const clearError = () => ({
  type: types.SELECTED_FOR_VERIFICATION_CLEAR_ERROR,
});

export const getAvailableToDecline = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SELECTED_FOR_VERIFICATION_LOADING, true));
    try {
      const statusResponse = await MPWWebApi.getGeneric(
        `Verification/GetAvailableToDecline`
      );

      if (
        statusResponse &&
        statusResponse.data &&
        !isNil(statusResponse.data.Data)
      ) {
        dispatch({
          type: types.SELECTED_FOR_VERIFICATION_AVAILABLE_TO_DECLINE,
          payload: statusResponse.data.Data,
        });
      }
    } catch (ex) {
      dispatch(error(types.SELECTED_FOR_VERIFICATION_ERROR, ex));
    } finally {
      dispatch(loading(types.SELECTED_FOR_VERIFICATION_LOADING, false));
    }
  };
};

export const declineToVerify = (householdId) => {
  return async (dispatch, getState, MPWWebApi) => {
    const state = getState();
    const applicationFilters = SelectedForVerificationSelectors.getApplicationFilters(
      state
    );
    const isConfirmationReview = SelectedForVerificationSelectors.getIsConfirmationReview(
      state
    );
    let obj = {
      applicationFilters,
      isConfirmationReview,
    };
    dispatch(loading(types.SELECTED_FOR_VERIFICATION_LOADING, true));
    try {
      const statusResponse = await MPWWebApi.getGeneric(
        `Verification/WriteDeclineToVerify/${householdId}`
      );

      if (statusResponse.status === 200) {
        dispatch(success(types.DECLINE_FOR_VERIFICATION_SUCCESS));
        dispatch(getAvailableToDecline());
        dispatch(getSelectedForVerification(obj));
      }
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.SELECTED_FOR_VERIFICATION_ERROR, {
          Title: 'Error',
          Message: 'Unable to replace application for verification.',
        })
      );
    } finally {
      dispatch(loading(types.SELECTED_FOR_VERIFICATION_LOADING, false));
    }
  };
};

export const saveSelectionFilterOption = (isConfirmationReview) => ({
  type: types.SAVE_SELECTED_FILTER_OPTION,
  payload: isConfirmationReview,
});

export const saveFilters = (obj) => {
  return (dispatch, getState) => {
    const applicationFilters = SelectedForVerificationSelectors.getApplicationFilters(
      getState()
    );

    obj = { ...applicationFilters, ...obj };

    dispatch({
      type: types.SELECTED_FOR_VERIFICATION_SAVE_FILTERS,
      payload: obj,
    });
  };
};



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/state/actions.js